(function () {
  'use strict';

  if (window.AnatomyCustomerPrivacy) return;

  var listeners = [];
  var startedAt = Date.now();
  var loadAttempted = false;
  var readySettled = false;
  var retryTimer = null;
  var timeoutTimer = null;
  var timeoutOverride = Number(window.__ANATOMY_PRIVACY_TIMEOUT_MS__ || 0);
  var timeoutMs = timeoutOverride >= 50 && timeoutOverride <= 8000 ? timeoutOverride : 8000;
  var state = {
    status: 'loading',
    analytics_processing_allowed: false,
    marketing_allowed: false,
    sale_of_data_allowed: false,
    preferences_processing_allowed: false,
    reason: 'initializing'
  };
  var resolveReady;
  var readyPromise = new Promise(function (resolve) {
    resolveReady = resolve;
  });

  function copyState() {
    return {
      status: state.status,
      analytics_processing_allowed: state.analytics_processing_allowed,
      marketing_allowed: state.marketing_allowed,
      sale_of_data_allowed: state.sale_of_data_allowed,
      preferences_processing_allowed: state.preferences_processing_allowed,
      reason: state.reason
    };
  }

  function statesEqual(left, right) {
    return left.status === right.status
      && left.analytics_processing_allowed === right.analytics_processing_allowed
      && left.marketing_allowed === right.marketing_allowed
      && left.sale_of_data_allowed === right.sale_of_data_allowed
      && left.preferences_processing_allowed === right.preferences_processing_allowed
      && left.reason === right.reason;
  }

  function notify() {
    var snapshot = copyState();
    listeners.slice().forEach(function (listener) {
      try {
        listener(snapshot);
      }
      catch (error) {}
    });
  }

  function settleReady() {
    if (readySettled || state.status === 'loading') return;
    readySettled = true;
    resolveReady(copyState());
  }

  function publish(nextState) {
    if (statesEqual(state, nextState)) return;
    state = nextState;
    notify();
    settleReady();
  }

  function deniedState(status, reason) {
    return {
      status: status,
      analytics_processing_allowed: false,
      marketing_allowed: false,
      sale_of_data_allowed: false,
      preferences_processing_allowed: false,
      reason: reason
    };
  }

  function clearTimers() {
    if (retryTimer !== null) {
      window.clearTimeout(retryTimer);
      retryTimer = null;
    }
    if (timeoutTimer !== null) {
      window.clearTimeout(timeoutTimer);
      timeoutTimer = null;
    }
  }

  function fail(reason) {
    if (state.status === 'error') return;
    clearTimers();
    publish(deniedState('error', reason));
  }

  function readAllowed(api, methodName) {
    if (!api || typeof api[methodName] !== 'function') return false;
    return api[methodName]() === true;
  }

  function refresh() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api) {
      fail('customer_privacy_unavailable');
      return;
    }

    try {
      publish({
        status: 'ready',
        analytics_processing_allowed: readAllowed(api, 'analyticsProcessingAllowed'),
        marketing_allowed: readAllowed(api, 'marketingAllowed'),
        sale_of_data_allowed: readAllowed(api, 'saleOfDataAllowed'),
        preferences_processing_allowed: readAllowed(api, 'preferencesProcessingAllowed'),
        reason: 'authoritative_method_readback'
      });
      clearTimers();
    }
    catch (error) {
      fail('customer_privacy_read_failed');
    }
  }

  function onConsentCollected() {
    if (state.status === 'ready') refresh();
  }

  function scheduleLoadRetry() {
    if (Date.now() - startedAt >= timeoutMs) {
      fail('load_features_timeout');
      return;
    }
    retryTimer = window.setTimeout(attemptLoad, 25);
  }

  function attemptLoad() {
    if (loadAttempted || state.status === 'error') return;
    var shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== 'function') {
      scheduleLoadRetry();
      return;
    }

    loadAttempted = true;
    try {
      shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' }
      ], function (error) {
        if (state.status === 'error') return;
        if (error) {
          fail('load_features_failed');
          return;
        }
        refresh();
      });
    }
    catch (error) {
      fail('load_features_threw');
    }
  }

  function subscribe(listener) {
    if (typeof listener !== 'function') return function () {};
    listeners.push(listener);
    try {
      listener(copyState());
    }
    catch (error) {}
    return function () {
      var index = listeners.indexOf(listener);
      if (index !== -1) listeners.splice(index, 1);
    };
  }

  function whenReady(callback) {
    var promise = readyPromise.then(function () {
      return copyState();
    });
    if (typeof callback !== 'function') return promise;
    return promise.then(function (snapshot) {
      callback(snapshot);
      return snapshot;
    });
  }

  function analyticsAllowed() {
    return state.status === 'ready' && state.analytics_processing_allowed === true;
  }

  function marketingAllowed() {
    return state.status === 'ready' && state.marketing_allowed === true;
  }

  function advertisingAllowed() {
    return state.status === 'ready'
      && state.marketing_allowed === true
      && state.sale_of_data_allowed === true;
  }

  function identityAllowed() {
    return state.status === 'ready'
      && state.analytics_processing_allowed === true
      && state.marketing_allowed === true;
  }

  var manager = {
    snapshot: copyState,
    whenReady: whenReady,
    subscribe: subscribe,
    analyticsAllowed: analyticsAllowed,
    marketingAllowed: marketingAllowed,
    advertisingAllowed: advertisingAllowed,
    identityAllowed: identityAllowed
  };

  window.AnatomyCustomerPrivacy = manager;
  window.anatomyCustomerPrivacy = manager;

  document.addEventListener('visitorConsentCollected', onConsentCollected);
  window.addEventListener('visitorConsentCollected', onConsentCollected);

  var consumers = window.AnatomyPrivacyConsumers || [];
  window.AnatomyPrivacyConsumers = [];
  consumers.forEach(function (consumer) {
    if (typeof consumer !== 'function') return;
    try {
      consumer(manager);
    }
    catch (error) {}
  });

  timeoutTimer = window.setTimeout(function () {
    fail('load_features_timeout');
  }, timeoutMs);
  attemptLoad();
})();
